import React from 'react'
import PropTypes from 'prop-types'

const RadioInputBuilder = ({id, inputValue, inputLabel, inputName, inputChecked, onClick}) => (
    <li key={id}><label><input type="radio" name={inputName} defaultValue={inputValue} checked={inputChecked} onChange={(e) => onClick(e,id)}/> {inputLabel}</label></li>
)
RadioInputBuilder.propTypes = {
  id: PropTypes.number.isRequired,
  inputValue: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

export default RadioInputBuilder

export let CPN = [
  { id: 0, inputValue: '10', inputLabel: '10件', inputName:'cpn', inputChecked:true },
  { id: 1, inputValue: '20', inputLabel: '20件', inputName:'cpn', inputChecked:false },
  { id: 2, inputValue: '50', inputLabel: '50件', inputName:'cpn', inputChecked:false },
]

export let ORD = [
  { id: 0, inputValue: 'd', inputLabel: '新着順', inputName:'ord', inputChecked:true },
  { id: 1, inputValue: 'p', inputLabel: '一致順', inputName:'ord', inputChecked:false },
]